import type { RouteLocationNormalizedGeneric } from 'vue-router';
import { pageMetaTypes } from 'ui/config/pages';

import { dashboard, login } from '../config/pages';
import useLoadApp from '../hooks/useLoadApp';
import useSaveSesionData from '../hooks/useSaveSesionData';

const redirectSession = (
  to: RouteLocationNormalizedGeneric,
  from: RouteLocationNormalizedGeneric,
  pageType?: pageMetaTypes,
  isLogged?: boolean,
  uuid?: string,
) => {
  // Pages by default are private
  if ((!pageType || pageType === pageMetaTypes.private) && !isLogged) {
    if (window.location.pathname === '/') {
      return navigateTo({ path: login });
    }
    const currentLocation = btoa(window.location.href);
    return navigateTo({ path: login, query: { redirect: currentLocation } });
  }

  if (pageType === pageMetaTypes.session && isLogged && !to.query.redirect) {
    let url = `${dashboard}`;
    if (uuid) {
      url = `${dashboard}${uuid}`;
    }
    return navigateTo(url, { replace: true });
  }

  // it should be here always -> except for user without entities
  // it could happnes, but it's wrong data in DB
  // we should display an special page for that case
  if (to.path === dashboard && uuid && !to.query.redirect) {
    const url = `${dashboard}${uuid}`;
    return navigateTo(url, { replace: true });
  }

  return () => {};
};

export default defineNuxtRouteMiddleware(async (to, from) => {
  const pageType = to.meta.type as pageMetaTypes;
  const isFromLogin = (from.path === login) && (to.path !== login);
  const { user } = useMmaBaseUser();
  const firstLoad = useLoadInit();
  const uuid = useEntityUuid();
  const { onSave } = useSaveSesionData();
  if (!firstLoad.value || isFromLogin || !user.value) {
    const { getSessionData } = useLoadApp();
    try {
      const response = await getSessionData();
      if ('entities' in response) { // this is an user
        const firstEntity = response.entities[0];
        if (firstEntity) {
          uuid.value = firstEntity.uuid;
        }
      } else {
        uuid.value = response.uuid ?? '';
      }
      onSave(response);
    } catch (error) {
      // don't do anything -> could be a 401 - unauthorize
      // Review it "unauthorize" will reload the page

      console.log('error', error);
    }
    firstLoad.value = true;
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return redirectSession(to, from, pageType, !!user.value, uuid.value) as any;
});
